export default __webpack_public_path__ + "static/media/united.19c6b862.png";